import { render } from "./bundle-list.vue?vue&type=template&id=3743e920"
import script from "./bundle-list.vue?vue&type=script&lang=js"
export * from "./bundle-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__